import { getMaterial } from '../common/Materials'
import { materialTypes } from '../common/MaterialTypes'

export const referenceEdgeConfig = {
  vertex: {
    innerActiveMaterial: getMaterial(materialTypes.transparent),
    innerInactiveMaterial: getMaterial(materialTypes.transparent),
    outerActiveMaterial: getMaterial(materialTypes.transparent),
    outerInactiveMaterial: getMaterial(materialTypes.transparent),
    innerSize: 0.1,
    outerSize: 0.3,
  },
  edge: {
    innerActiveMaterial: getMaterial(materialTypes.orange),
    innerInactiveMaterial: getMaterial(materialTypes.orange),
    outerActiveMaterial: getMaterial(materialTypes.transparent),
    outerInactiveMaterial: getMaterial(materialTypes.transparent),
    innerSize: 0.1,
    outerSize: 0.3,
  },
  properties: {}
}